module.exports = __webpack_public_path__ + "static/media/Features-Items.5ee7a4eb.png";